<template>
  <section class="courses-section">
    <div class="container">
      <div class="section-header">
        <p class="section-subtitle">جديد على المنصة</p>
        <h2 class="section-title">
          آخر <span class="hero-subtext">الكورسات</span> المضافة
        </h2>
        <p class="section-desc">
          تصفّح أحدث الكورسات التي تم إضافتها مؤخرًا، وابدأ رحلة تعلمك الآن.
        </p>
      </div>
      <!-- الكروت -->
      <div class="courses-grid">
        <CourseCard 
          v-for="course in courses.slice(0, 3)" 
          :key="course.id" 
          :course="course" 
          @watch="goToCourse(course.id)"
        />
      </div>

      <div @click="goToAllCourses" class="view-all">
        <button class="view-btn">
          رؤية الكل 
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
          </svg>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import CourseCard from "@/components/CoursesPage/CourseCard.vue";
import apiService from "@/apiService";

export default {
  name: "CoursesSection",
  components: { CourseCard },
  data() {
    return {
      courses: []
    };
  },
  async mounted() {
    try {
      const response = await apiService.getLatestCourses();
      console.log("Latest Courses response:", response);
      this.courses = response.data.courses || response.data.data || [];
    } catch (error) {
      console.error("error fetching courses:", error);
    }
  },
  methods: {
    goToCourse(id) {
      const token = this.$store.state.studentToken;
    if (token) {
      this.$router.push(`/courses/${id}`);
    } else {
      this.$router.push("/login");
    }
    },
    goToAllCourses() {
      const token = this.$store.state.studentToken;
      if (token) {
        this.$router.push("/courses");
      } else {
        this.$router.push("/login");
      }
    }
  }
};
</script>

<style scoped>
.courses-section {
    background-color: #FFEFD6;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 60px 20px;
}
.section-header {
  text-align: center;
}
.section-subtitle {
  color: #FF9A18;
  font-size: 22px;
  font-weight: 400;
  margin-bottom: 24px;
}

.section-title {
  font-size: 54px;
  font-weight: bold;
  margin-bottom: 24px;
  color: #000;
}

.section-desc {
  color: #7F8685;
  font-size: 22px;
  font-weight: 400;
  margin-bottom: 40px;
  text-align: center;
}

.courses-grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  /* max-width: 1200px; */
}

.course-card {
  background: #fff;
  padding: 12px;
  border-radius: 24px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
}
.course-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 28px rgba(0,0,0,.12);
  background-color: transparent;
}

.hover-gradient::before{
  content:"";
  position:absolute; inset:0;
  border-radius: inherit;
  padding: 2px;
  background: linear-gradient(135deg, #00c4c7, #ff9a18);
  -webkit-mask:
     linear-gradient(#000 0 0) content-box,
     linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
          mask-composite: exclude;
  opacity: 0;
  transition: opacity .25s ease;
  pointer-events: none;                
}
.hover-gradient:hover::before{
  opacity: 1;
}
.course-img {
  width: 100%;
  height: 260px;
  object-fit: cover;
  border-radius: 24px;
}

.course-info {
  text-align: right;
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 0;
}

.course-title {
  font-size: 26px;
  font-weight: bold;
  color: #000;
  margin: 0;
}

.course-subtitle {
  font-size: 16px;
  color: #7F8685;
  font-weight: 500;
  margin: 6px 0 12px;
}

.course-meta {
  display: flex;
  flex-direction: column;
  gap: 12px;
  color: #000;
}
.course-meta span {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 500;
    align-self: end;
}

.course-meta .tag {
  background: #7F868533;
  padding: 4px 8px;
  border-radius: 25px;
  font-weight: 500;
  font-size: 16px;
}

.watch-btn {
  background: #ff9800;
  color: #fff;
  border: none;
  padding: 12px;
  border-radius: 24px;
  cursor: pointer;
  width: 100%;
  font-size: 20px;
  font-weight: bold;
  transition: background 0.3s;
}

.watch-btn:hover {
  background: #e68900;
}

.view-all {
  margin-top: 30px;
  text-align: center;
}

.view-btn {
  background: #FF9A18;
  color: #fff;
  border: none;
  padding: 13px;
  border-radius: 25px;
  font-size: 20px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s;
}

.view-btn:hover {
  background: #e68900;
}
.view-btn svg {
  animation: arrowMove 1s infinite alternate ease-in-out;
}

@keyframes arrowMove {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-6px);
  }
}
@media (max-width: 992px) {
  .courses-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}


@media (max-width: 576px) {
    .course-title {
        font-size: 22px;
    }
  .courses-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

}
</style>
